<template>
  <div class="title">
    <h1>バーコードスキャン</h1>
    <p>JANコード（EAN（European Article Number）コード）を取得できます。</p>
    <div>
      <p>Scanボタンを押して、お使いの端末のカメラでバーコードをスキャンしてください。</p>
      <p>Stopを押下すると、バーコードのスキャンを確定させます。</p>
    </div>
    <p>注）カメラ機能のないデバイスではご利用できません</p>
  </div>

  <div class="center">
    <div style="margin: 20px;">
      <span style="color: red;">赤い横線</span>が読み取ったバーコードになります。<br>
      <span style="color: rgb(48, 95, 0);">緑の枠線</span>でバーコードを特定しています。<br>
    </div>
    <!-- カメラ映像表示領域 -->
    <div id="cameraArea">
      <img v-if="!code.includes('-')" src="" alt="result" class="resultImg" />
    </div>

    <!-- コード表示 -->
    <p class="resultCode" id="resultCode">{{ code }}</p>

    <div class="button">
      <!-- スキャン開始ボタン -->
      <button @click="startScan" class="bottun-font">Scan</button>
      <!-- スキャン停止ボタン -->
      <button aria-label="close" @click.prevent.stop="stopScan" class="bottun-font">Stop</button>
    </div>
  </div>
  <div class="option">
    <p>開発言語：javascript</p>
    <p>開発言語フレームワーク：vue.js</p>
  </div>
</template>

<script>
export default {
  name: "BarcodeScanner",
  data() {
    return {
      Quagga: null,  // Quaggaライブラリの初期化
      code: "-----------------------"       // 読み取ったバーコードのコード
    };
  },
  methods: {
    startScan() {
      this.code = "-----------------------";
      this.initQuagga();
    },
    stopScan() {
      // スキャン停止時の処理
      try {
        this.Quagga.offProcessed(this.onProcessed);
        this.Quagga.offDetected(this.onDetected);
        this.Quagga.stop();
      } catch (err) {
        console.log(err)
      }

    },
    initQuagga() {
      // Quaggaライブラリの初期化と設定
      this.Quagga = require("quagga");
      this.Quagga.onProcessed(this.onProcessed);
      this.Quagga.onDetected(this.onDetected);

      const config = {
        inputStream: {
          name: "Live",
          type: "LiveStream",
          target: document.querySelector("#cameraArea"),
          constraints: { facingMode: "environment" }
        },
        numOfWorkers: navigator.hardwareConcurrency || 4,
        decoder: { readers: ["ean_reader", "ean_8_reader"] }
      };
      this.Quagga.init(config, this.onInit);
    },
    onInit(err) {
      if (err) {
        console.log(err);
        return;
      }
      console.info("Initialization finished. Ready to start");
      this.Quagga.start();  // スキャン開始
    },
    onDetected(success) {
      this.code = success.codeResult.code;
      // 取得時の画像を表示
      if (this.code) {
        this.$nextTick(() => {
          const $resultImg = document.querySelector(".resultImg");
          $resultImg.setAttribute("src", this.Quagga.canvas.dom.image.toDataURL());
          this.Quagga.stop();  // スキャン停止
        });
      }
    },
    onProcessed(result) {
      // スキャン中の処理
      const drawingCtx = this.Quagga.canvas.ctx.overlay;
      const drawingCanvas = this.Quagga.canvas.dom.overlay;

      if (result) {
        // 検出中の緑の線の枠
        if (result.boxes) {
          drawingCtx.clearRect(0, 0, drawingCanvas.width, drawingCanvas.height);
          const filteredBoxes = [];

          for (const box of result.boxes) {
            if (box !== result.box) {
              filteredBoxes.push(box);
            }
          }

          for (const box of filteredBoxes) {
            this.Quagga.ImageDebug.drawPath(box, { x: 0, y: 1 }, drawingCtx, {
              color: "green",
              lineWidth: 2
            });
          }
        }

        // 検出に成功した瞬間の青い線の枠
        if (result.box) {
          this.Quagga.ImageDebug.drawPath(
            result.box,
            { x: 0, y: 1 },
            drawingCtx,
            {
              color: "blue",
              lineWidth: 2
            }
          );
        }

        // 検出に成功した瞬間の水平の赤い線
        if (result.codeResult && result.codeResult.code) {
          this.Quagga.ImageDebug.drawPath(
            result.line,
            { x: "x", y: "y" },
            drawingCtx,
            {
              color: "red",
              lineWidth: 3
            }
          );
        }
      }
    }
  }
};
</script>

<style>
p {
  margin-block-start: 0.5em;
  margin-block-end: 0;
}

.title {
  margin: 20px auto;
}

.title p {
  margin: 0;
  padding: 0;
}

@media (max-width: 550px) {
  .title {
    width: 100%
  }

  .center {
    margin-top: 35px;
    width: 100% !important
  }
}

#cameraArea {
  overflow: hidden;
  width: 320px;
  height: 240px;
  margin: auto;
  position: relative;
  display: flex;
  align-items: center;
  background-color: #333;
}

#cameraArea video {
  width: 320px;
  height: 240px;
}

@media (max-width: 750px) {

  .resultImg,
  .center {
    width: 90% !important;
    height: 240px;
  }

  #cameraArea {
    width: 320px
  }

  #resultCode {
    margin: 20px auto !important;
    width: 320px;
  }
}

#cameraArea canvas {
  width: 320px;
  height: 240px;
  position: absolute;
  left: 0px;
  top: 0px;
}


button {
  width: 100px;
  height: 40px;
  background-color: #fff;
  border: 1px solid #333;
}

.resultImg {
  width: 320px;
  height: 240px;
  position: absolute;
  left: 0px;
  top: 0px;
}

.resultCode {
  padding: initial !important;
  background-color: #f1f0f0;
  align-content: center;
  height: 60px;
  border: 2px solid;
  margin: 17px 187px !important;
  color: rgb(131, 130, 130);
  font-size: 26px !important;
  font-weight: bold;
  text-align: center;
}

.bottun-font {
  font-size: 20px;
  font-family: math;
}

.button {
  display: grid;
  grid-auto-columns: 100px;
  grid-auto-flow: column;
  justify-content: center;
  gap: 4rem;
  margin: 40px;
}

.center {
  line-height: 1.8;
  width: 700px;
  height: auto;
  border-collapse: collapse;
  border: 1px solid #dddddd;
  padding: 0px 0px 0px 0px;
  margin: 35px auto 10px;
  background-color: #f7f7f7;
}

.option {
  padding: 20px 0px 50px;
  margin: 0 0 20px 0;
}

.option p {
  margin: 0;
  padding: 0;
}
</style>